import { Component, inject, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { filter, map } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { LandlordRoleService } from '../../core/services/landlord-role.service';

@Component({
  selector: 'app-bottom-navbar',
  imports: [
    MatIconModule,
    RouterLinkActive,
    RouterLink,
    NgClass
  ],
  templateUrl: './bottom-navbar.component.html',
  standalone: true,
  styleUrl: './bottom-navbar.component.scss'
})
export class BottomNavbarComponent implements OnInit {

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private landlordRoleService = inject(LandlordRoleService);

  show = signal(true);
  selected = 'explore';

  isLandlord = this.landlordRoleService.isLandlord;

  tenantNavItems = [
    { id: '/list', icon: 'home', label: $localize`:@@ui-common.bottom-navbar.tenant.home:Home` },
    { id: '/viewings', icon: 'calendar', label: $localize`:@@ui-common.bottom-navbar.tenant.viewings:Viewings` },
    { id: '/offers', icon: 'handcoin', label: $localize`:@@ui-common.bottom-navbar.tenant.offers:Offers` },
    { id: '/tenancies', icon: 'key', label: $localize`:@@ui-common.bottom-navbar.tenant.tenancies:Tenancies` }
  ];

  landlordNavItems = [
    { id: '/landlord/listing', icon: 'home', label: $localize`:@@ui-common.bottom-navbar.landlord.listing:Listings` },
    { id: '/landlord/appointments', icon: 'calendar', label: $localize`:@@ui-common.bottom-navbar.landlord.appointments:Appointments` },
    { id: '/landlord/offers', icon: 'handcoin', label: $localize`:@@ui-common.bottom-navbar.landlord.offers:Offers` },
    { id: '/landlord/tenancies', icon: 'key', label: $localize`:@@ui-common.bottom-navbar.landlord.tenancies:Tenancies` }
  ];

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.findBottomNavData(this.route.root))
    ).subscribe((show: boolean) => {
      this.show.set(show !== false);
    });
  }

  private findBottomNavData(route: ActivatedRoute): boolean | undefined {
    let currentRoute: ActivatedRoute | null = route;

    while (currentRoute) {
      if (Object.prototype.hasOwnProperty.call(currentRoute.snapshot.data, 'bottomNav')) {
        return currentRoute.snapshot.data['bottomNav'];
      }
      currentRoute = currentRoute.firstChild ?? null;
    }

    return undefined;
  }


}
